import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة باقي القسمة - احسب باقي القسمة بين عددين بدقة";
const DESCRIPTION =
  "تعتبر حاسبة باقي القسمة أداة متقدمة ومفيدة لاحتساب باقي القسمة بين عددين بسرعة ودقة. باستخدام هذه الحاسبة، يمكنك معرفة الناتج المتبقي بعد تقسيم عدد على عدد آخر، وهو مفيد في مجالات متعددة مثل الرياضيات، البرمجة، وتحليل البيانات. احصل على نتائج دقيقة وسريعة بسهولة تامة.";
const KEYWORDS =
  "باقي القسمة, حاسبة باقي القسمة, حاسبة رياضيات, باقي القسمة في الرياضيات, أدوات حسابية, تشفير, تحليل بيانات";
const OG_URL = "https://do-calculate.com/calculator/ar/remainder-calculator/";
const RemainderCalculator = () => {
  const [dividend, setDividend] = useState("");
  const [divisor, setDivisor] = useState("");
  const [remainder, setRemainder] = useState("");
  const [error, setError] = useState("");
  const calculateRemainder = (dividend, divisor) => {
    const quotient = Math.floor(dividend / divisor);
    return dividend - quotient * divisor;
  };
  const handleCalculate = () => {
    try {
      const dividendValue = parseFloat(dividend);
      const divisorValue = parseFloat(divisor);
      if (dividend && divisor) {
        const calculatedRemainder = calculateRemainder(
          dividendValue,
          divisorValue
        );
        setRemainder(calculatedRemainder.toFixed(2));
        setError("");
      } else {
        throw new Error("يرجى إدخال جميع القيم لحساب باقي القسمة.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة باقي القسمة</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة باقي القسمة هي أداة قوية ومفيدة تستخدم لحساب باقي القسمة
                  بين عددين بدقة وسرعة. تعمل هذه الحاسبة على تقديم نتيجة دقيقة
                  للناتج المتبقي عند تقسيم عدد على عدد آخر، وهو أمر أساسي في
                  العديد من التطبيقات العملية مثل الرياضيات والبرمجة. في
                  الرياضيات، يتم استخدام باقي القسمة لحل المشكلات المتعلقة
                  بالأعداد الصحيحة وتبسيط المعادلات. في مجال التشفير، يعد حساب
                  باقي القسمة عنصرًا حيويًا لضمان أمان البيانات ومعالجتها بشكل
                  صحيح. باستخدام هذه الحاسبة، يمكنك الحصول على نتائج سريعة
                  وموثوقة لتحسين كفاءتك في مختلف المجالات.
                </p>
              </div>
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة باقي القسمة</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          المقسوم (العدد الأول)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل العدد المقسوم"
                        value={dividend}
                        onChange={(e) => setDividend(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">عدد صحيح</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          المقسوم عليه (العدد الثاني)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل العدد المقسوم عليه"
                        value={divisor}
                        onChange={(e) => setDivisor(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">عدد صحيح</span>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { remainder && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتائج:</p>
                        <p>باقي القسمة: {remainder}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو باقي القسمة؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                باقي القسمة هو العدد المتبقي بعد قسمة عددين صحيحين. يتم حساب
                باقي القسمة عندما نقوم بقسمة عدد (المقسوم) على عدد آخر (المقسوم
                عليه)، ونطرح من الناتج الجزء الصحيح المضاعف للعدد المقسوم عليه.
              </p>
              <p>
                على سبيل المثال، إذا قسمنا 17 على 5، فإن الناتج الصحيح هو 3، مما
                يعني أن 5 مضروبة في 3 تساوي 15. نطرح 15 من 17 لنحصل على الباقي
                الذي هو 2. لذلك، باقي قسمة 17 على 5 هو 2.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>كيف يتم حساب باقي القسمة؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                لحساب باقي القسمة باستخدام حاسبتنا، أدخل العدد الذي ترغب في
                قسمته والعدد الذي تقسم عليه، واضغط على زر "احسب". ستقوم حاسبة
                باقي القسمة بحساب الجزء الصحيح من القسمة ثم تحديد الباقي.
              </p>
              <p>على سبيل المثال، لحساب باقي قسمة 81 على 11:</p>
              <ul>
                <li>قسّم 81 على 11 لتحصل على 7.36363636.</li>
                <li>احسب الجزء الصحيح من الناتج، وهو 7.</li>
                <li>اضرب 7 في 11، لتجد أن 77.</li>
                <li>اطرح 77 من 81، لتحصل على الباقي وهو 4.</li>
              </ul>
              <p>
                باستخدام حاسبتنا، يمكنك إدخال 81 و11 للحصول على باقي القسمة
                مباشرةً، والذي هو 4 في هذه الحالة.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                استخدامات باقي القسمة في التشفير
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                يستخدم باقي القسمة بشكل واسع في العديد من مجالات التشفير، حيث
                يُعتبر جزءًا أساسيًا في خوارزميات التشفير مثل خوارزمية RSA. في
                التشفير، يُستخدم باقي القسمة لتأمين البيانات وضمان تشفيرها بشكل
                صحيح.
              </p>
              <p>
                على سبيل المثال، في خوارزمية RSA، يتم استخدام العمليات الرياضية
                التي تشمل باقي القسمة لضمان الأمان. فهم كيفية حساب باقي القسمة
                بدقة يمكن أن يكون حاسمًا في تطوير أنظمة التشفير الآمنة.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RemainderCalculator;
